import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

export default function Player(): React.JSX.Element {
  const { id } = useParams();
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const controller = new AbortController();
    async function load() {
      try {
        const res = await fetch(`/api/player/${id}`, { signal: controller.signal });
        setData(await res.json());
      } finally {
        setLoading(false);
      }
    }
    if (id) load();
    return () => controller.abort();
  }, [id]);

  if (loading) return <p>Loading...</p>;
  if (!data) return <p>Not found</p>;

  return (
    <div>
      <h2>{data.player?.web_name}</h2>
      <pre style={{ background: '#f6f8fa', padding: 12, overflow: 'auto' }}>{JSON.stringify(data, null, 2)}</pre>
    </div>
  );
}



